export default __webpack_public_path__ + "static/media/assemble.d2190d7d.mp4";